
export const capitalizeFirstLetter = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export const parseTRDate = (str: string): Date => {
    if (!str.includes(".")) return new Date("Invalid");

    const [day, month, rest] = str.split(".");
    const [year, time] = rest.split(" ");
    const isoString = `${year}-${month}-${day}T${time || "00:00:00"}`;

    return new Date(isoString);
};

